import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

// SPEC-web-planner-033 AC-10 / DESIGN-RULES R3 — the one standard confirmation for an action that deletes,
// removes or turns off saved data at once. Built on app-modal-overlay (Escape and the backdrop emit
// closeRequest). Text is interpolated, never innerHTML. While `busy`, Cancel, Escape and the backdrop do nothing.
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
    @Input() open = false;
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() message = '';
    @Input() confirmLabel = 'Delete';
    /** DESIGN-RULES R7: "Keep editing" on the discard-changes ask; every other use keeps 'Cancel'. */
    @Input() cancelLabel = 'Cancel';
    /** SPEC-web-planner-040: 'danger' (red, the default: R3 destructive) or 'primary' for a non-destructive confirm such as Share. */
    @Input() confirmTone: 'danger' | 'primary' = 'danger';
    @Input() busyLabel = 'Working…';
    @Input() busy = false;

    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    onConfirm(): void {
        if (this.busy) { return; }
        this.confirm.emit();
    }

    onCancel(): void {
        if (this.busy) { return; }
        this.cancel.emit();
    }
}
